export const LocationPlaceType = {
    Address: 'address',
    All: 'all',
    City: 'city',
    CityAndSuburb: 'city_and_suburb',
    Country: 'country',
    District: 'district',
    Place: 'place',
    Postcode: 'postcode',
    Region: 'region',
    State: 'state',
    Suburb: 'suburb',
    SuburbMixed: 'suburb_mixed',
} as const;

export type LocationPlaceType =
    (typeof LocationPlaceType)[keyof typeof LocationPlaceType];
